import {
    NinchatState,
    NinchatStore,
} from 'api/types'
import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmFoundEvent} from '../types/events'
import {describeRealm} from 'api/action/describeRealm'

export const realmFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        realm_attrs,
        realm_members,
        realm_settings,
        ...rest
    } = extractProperties<NinchatRealmFoundEvent>(action.payload)

    isEmpty(rest)

    const isUserRealm = !!realm_members

    const _realm_members: NinchatStore.NinchatRealmMembersStore = {}

    for (const user_id of Object.keys(realm_members ?? {})) {
        const {
            user_attrs,
            ...realm_member
        } = realm_members?.[user_id] ?? {}

        if (user_id === state.user_id) {
            state.user_attrs = user_attrs ?? {}
        } else {
            state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser
            state._users[user_id].user_attrs = user_attrs ?? {}
        }

        _realm_members[user_id] = realm_member
    }

    const realms = isUserRealm ? state.user_realms : state._realms ??= {}

    const _describe = describeRealm.fulfilled.match(action) ? 'fulfilled' : realms[realm_id]?._describe

    realms[realm_id] = {
        ..._describe && {_describe},
        realm_attrs,
        ...realm_members && {realm_members: _realm_members},
        ...realm_settings && {realm_settings},
    }

    if (isUserRealm && state._realms) {
        delete state._realms[realm_id]
    }
}
